import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '../../core/ModalGroup';
import ModalTabMultipleGroups from './ModalTabMultipleGroups';

// eslint-disable-next-line react/prefer-stateless-function
class ModalMultipleGroups extends Component {
  render() {
    const { onClose, onSaveGroup, ...rest } = this.props;
    return (
      <Modal title="SELECCIONAR GRUPOS DE USUARIOS" onClose={onClose}>
        <ModalTabMultipleGroups onSaveGroup={onSaveGroup} {...rest} />
      </Modal>
    );
  }
}

ModalMultipleGroups.propTypes = {
  onClose: PropTypes.func,
  onAddGroupId: PropTypes.func,
  addSelectedUsers: PropTypes.shape()
};

export default ModalMultipleGroups;
